import { render, staticRenderFns } from "./displaced.vue?vue&type=template&id=3bc54d9c"
import script from "./displaced.vue?vue&type=script&lang=js"
export * from "./displaced.vue?vue&type=script&lang=js"
import style0 from "./displaced.vue?vue&type=style&index=0&id=3bc54d9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports